<template>
    <div v-loading="loading">
        <div class="title">必修課程</div>
        <div class="flex-layout">
            <div class="p-pointer" v-for="(item) in necessary" :key="item.id"  @click="$router.push({path:'/home/lessons/study',query:{id:item.id, title:item.name}})">
                <LessonCard :data="item" />
            </div>
            <div style="width: 100%;text-align: center;padding-bottom:20px;" v-show="necessary.length === 0">
                <empty title="暫無課程"></empty>
            </div>
        </div>
        <div class="title">選修課程</div>
        <div class="flex-layout">
            <div class="p-pointer" v-for="(item) in choosable" :key="item.id" @click="$router.push({path:'/home/lessons/study',query:{id:item.id, title:item.name}})">
                <LessonCard :data="item" />
            </div>
            <div style="width: 100%;text-align: center;padding-bottom:20px;" v-show="choosable.length === 0">
                <empty title="暫無課程"></empty>
            </div>
        </div>
    </div>
</template>

<script>
import LessonCard from '@p/components/lessonCard';
import empty from '@p/components/contentEmpty';
import { setTimeStr,setAllCourseData } from '@/utils';
export default {
    components:{ LessonCard, empty },
    data(){
        return{
            choosable:[],
            necessary:[],
            loading:false,
        }
    },
    created() {
        this.initDate();
    },
    watch:{
        
    },
    mounted(){
        
    },
    methods:{
        // 获得课程
        initDate(){
            this.loading = true;
            this.$http.personal.getMyCourse({type:'study',page:1,page_size:99999}).then(v=>{
                if(v.status === 200){
                    v.data.data.data.forEach(item => {
                        if(item[0].required === 0){
                            this.choosable.push(item[0])
                        }else if(item[0].required === 1){
                            this.necessary.push(item[0])
                        }
                    });
                }
                this.loading = false;
            }).catch(()=>{
                this.loading = false;
            })
        },
    }
}
</script>

<style lang="less" scoped>
.title{
    font-size: 16px;
    color:rgba(51,51,51,1);
    margin-top: 20px;
    margin-bottom: 10px;
}
</style>